import { Box } from "@chakra-ui/layout";
import { useState } from "react";
import Chatbox from "../components/Chatbox";
import MyChats from "../components/MyChats";
import SideDrawer from "../components/miscellaneous/SideDrawer";
import { ChatState } from "../Context/ChatProvider";
import "../components/ChatsDark.css";

const Chatpage = () => {
  // Counter (not boolean toggle) so rapid successive refreshes never get lost.
  const [fetchAgain, setFetchAgain] = useState(0);
  const { user } = ChatState();

  return (
    <div className="chats-stage">
      <div className="chats-glow chats-glow-a" />
      <div className="chats-glow chats-glow-b" />
      <div className="chats-content">
        {user && <SideDrawer />}
        <Box
          display="flex"
          justifyContent="space-between"
          w="100%"
          h="91.5vh"
          p="10px"
          gap="12px"
        >
          {user && <MyChats fetchAgain={fetchAgain} />}
          {user && (
            <Chatbox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
          )}
        </Box>
      </div>
    </div>
  );
};

export default Chatpage;
